var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8008 16.3913V9.79199L25.4008 16.3913M10.4009 7.99219C9.06896 7.99219 8.00098 9.06007 8.00098 10.3919V29.5898C8.00098 30.2263 8.25383 30.8366 8.70391 31.2867C9.15399 31.7367 9.76444 31.9896 10.4009 31.9896H24.8008C25.4373 31.9896 26.0477 31.7367 26.4978 31.2867C26.9479 30.8366 27.2007 30.2263 27.2007 29.5898V15.1914L20.0008 7.99219H10.4009Z",
    fill: "#9BA1A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.8014,
    y: 19.3922,
    width: 22.7997,
    height: 10.7989,
    rx: 1.79989,
    fill: "white",
    stroke: "#9BA1A3",
    strokeWidth: 1.19993
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4395 22.706V24.632H16.8785V25.5995H14.4395V28.25H13.2245V21.743H17.3285V22.706H14.4395ZM19.5372 28.25H18.3222V21.743H19.5372V28.25ZM24.8055 27.251V28.25H20.994V21.743H22.2045V27.251H24.8055ZM26.8848 22.706V24.5105H29.1618V25.442H26.8848V27.2825H29.7738V28.25H25.6698V21.743H29.7738V22.706H26.8848Z",
    fill: "#9BA1A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.f769ef29cfc429d88395bafaa07e02c2.svg";
export { ForwardRef as ReactComponent };